import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

const initalState = {
    loading: false,
    error: null,
    slides: [],
};

export const fetchSliderData = createAsyncThunk(
    'sliders/fetchSliderData',
    async ({type="all"}) => {
        try {
            const response = await api.get('/sliders', {
                params: {
                    type
                }
            });
            console.log("slider  : ",response.data)
            return response.data;    
        } catch (error) {
            console.log("error : ",error)
        }
        
    }
)

export const sliderSlice = createSlice({
    name: "slider",
    initialState: initalState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSliderData.fulfilled, (state, action) => {
                state.loading = false;
                state.slides = action.payload;
            })
            .addCase(fetchSliderData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});
export const { getSliderRequest, getSliderSuccess, getSliderFailure } = sliderSlice.actions;
export default sliderSlice.reducer;